import React from 'react';

import styles from '../../assets/styles/AppHome/ReminderCard.module.scss';
import { ReminderComponent as RC } from '../../components/Home';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { BsBellFill } from 'react-icons/bs';

const ReminderCard = () => {
	return (
		<div className={styles.reminder}>
			<div className={styles.reminder__title}>
				<h4 className={styles.reminder__title__text}>Reminders</h4>
				<div className={styles.reminder__title__icon}>
					<BsBellFill />
					<RiDeleteBin6Fill />
				</div>
			</div>
			<div className={styles.reminder__content}>
				<RC title="Create an Invoice for Bodmantech" time="18:20PM" />
				<RC title="Create an Invoice for Bodmantech" time="18:20PM" />
				<RC title="Create an Invoice for Bodmantech" time="18:20PM" />
				<RC title="Create an Invoice for Bodmantech" time="18:20PM" />
			</div>
		</div>
	);
};

export default ReminderCard;
